"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../icon"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _label = _interopRequireWildcard(require("./label"));

var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));

var _field = require("./field");

var _fieldsize = _interopRequireWildcard(require("./fieldsize"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Textfield = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Textfield, _Component);

  var _super = _createSuper(Textfield);

  function Textfield() {
    var _this;

    (0, _classCallCheck2.default)(this, Textfield);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      value: _this.props.value
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (event) {
      _this.setState({
        value: event.target.value
      });

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLabel", function (id) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_label.default, {
        className: (0, _classnames.default)(_this.props.classNames.label, (0, _defineProperty2.default)({}, _textfieldModule.default.errorLabel, _this.props.errorMessage)),
        for: id,
        tooltip: _this.props.tooltip,
        size: _this.props.size
      }, _this.props.label), /*#__PURE__*/_react.default.createElement(_label.SubLabel, {
        className: (0, _classnames.default)(_this.props.classNames.subLabel, (0, _defineProperty2.default)({}, _textfieldModule.default.errorLabel, _this.props.errorMessage)),
        size: _this.props.size
      }, _this.props.subLabel));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderField", function (id) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: _textfieldModule.default.fieldIconContainer
      }, /*#__PURE__*/_react.default.createElement("input", {
        ref: _this.props.innerRef,
        type: _this.props.type,
        name: _this.props.name,
        maxLength: _this.props.maxLength,
        autoComplete: _this.props.autoComplete,
        autoCorrect: _this.props.autoCorrect,
        id: id,
        "data-test-id": _this.props.dataTestId,
        value: _this.state.value,
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, _textfieldModule.default.field, _this.props.size === _fieldsize.default.DEFAULT), (0, _defineProperty2.default)({}, _textfieldModule.default.fieldSmall, _this.props.size === _fieldsize.default.SMALL), (0, _defineProperty2.default)({}, _textfieldModule.default.fieldInvalid, _this.props.errorMessage), _this.props.classNames.field),
        pattern: _this.props.pattern,
        min: _this.props.min,
        max: _this.props.max,
        disabled: _this.props.disabled,
        placeholder: _this.props.placeholder,
        "aria-label": _this.props.ariaLabel,
        step: _this.props.step,
        inputMode: _this.props.inputMode,
        onChange: _this.onChange,
        onBlur: _this.props.onBlur,
        onFocus: _this.props.onFocus
      }), _this.props.type === 'search' && /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: "medium",
        type: "search",
        className: (0, _classnames.default)(_textfieldModule.default.searchIcon, (0, _defineProperty2.default)({}, _textfieldModule.default.smallSearch, _this.props.size === _fieldsize.default.SMALL))
      })), _this.props.showCharacterCount && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(_textfieldModule.default.characterCountWrapper, _this.props.classNames.characterCountWrapper)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(_textfieldModule.default.characterCount, (0, _defineProperty2.default)({}, _textfieldModule.default.error, _this.exceedsMaxLength()))
      }, _this.getCharacterCount())), _this.props.errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
        size: _this.props.size,
        message: _this.props.errorMessage,
        className: _this.props.classNames.errorMessage
      }));
    });
    return _this;
  }

  (0, _createClass2.default)(Textfield, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState(function (_state, props) {
          return {
            value: props.value
          };
        });
      }
    }
  }, {
    key: "getSuggestedLength",
    value: function getSuggestedLength() {
      return this.props.suggestedLength || this.props.maxLength;
    }
  }, {
    key: "getCharacterCount",
    value: function getCharacterCount() {
      return this.getSuggestedLength() - this.state.value.length;
    }
  }, {
    key: "exceedsMaxLength",
    value: function exceedsMaxLength() {
      return this.state.value.length > this.getSuggestedLength();
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.id || (0, _field.makeIdString)();
      var wrapperOpts = {
        isHorizontal: this.props.isHorizontal,
        classNames: this.props.classNames
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(_textfieldModule.default.Textfield, this.props.classNames.wrapper, (0, _defineProperty2.default)({}, _textfieldModule.default.TextfieldHorizontal, this.props.isHorizontal))
      }, (0, _field.wrapIfHorizontal)(_objectSpread(_objectSpread({}, wrapperOpts), {}, {
        type: 'Label'
      }), this.renderLabel(id)), (0, _field.wrapIfHorizontal)(_objectSpread(_objectSpread({}, wrapperOpts), {}, {
        type: 'Field'
      }), this.renderField(id)));
    }
  }]);
  return Textfield;
}(_react.Component);

exports.default = Textfield;
Textfield.propTypes = _objectSpread({}, _field.textfieldPropTypes);
Textfield.defaultProps = _objectSpread({
  type: 'text',
  value: '',
  classNames: {},
  inputMode: 'text'
}, _fieldsize.fieldSizeDefaultProps);